<template>
	<div class="correct">
		<pheader :current="2"></pheader>

		<div class="correct-banner">
			<img :src="getpath('correct/banner', '.png?ran=1')" alt="">
		</div>

		<div class="bannerpad" :style="{backgroundImage:'url('+ getpath('correct/banner_padback','.png') +')'}">
			<img class="bannerinner" :src="getpath('/correct/banner_pad','.png')" alt="">
		</div>

		
		<div class="problem">
			<p class="atitle">
				<img class="titleline" :src="getpath('/correct/title_l','.png')" alt="">
				<img class="titleimg" :src="getpath('/correct/title_problem','.png')" alt="">
			</p>

			<img class="problemimg" :src="getpath('/correct/problemimg','.png?ran=2')" alt="">
		</div>

		<div class="help" :style="{backgroundImage:'url('+ getpath('/correct/helpback','.png') +')'}">
			<p class="htitle">
				<img class="titleline" :src="getpath('/correct/title_l','.png')" alt="">
				<img class="titleimg" :src="getpath('/correct/title_help','.png')" alt="">

				<img @click="gotodown('stick')" class="gocorrect"  :src="getpath('/correct/gocorrect','.png')" alt="">
			</p>

			<div class="ingobox" :style="{backgroundImage:'url('+ getpath('/correct/ingoimg','.png?ra=1') +')'}">
				<div class="ballbox">
					<div :class="ballcurrent==1?'ballitem ac':'ballitem'">
						<img class="sml" :src="getpath('/correct/help01_sml','.png')" alt="">
						<img class="big" :src="getpath('/correct/help01_big','.png')" alt="">
					</div>
					<div :class="ballcurrent==2?'ballitem ac':'ballitem'">
						<img class="sml" :src="getpath('/correct/help02_sml','.png')" alt="">
						<img class="big" :src="getpath('/correct/help02_big','.png')" alt="">
					</div>
					<div :class="ballcurrent==3?'ballitem ac':'ballitem'">
						<img class="sml" :src="getpath('/correct/help03_sml','.png')" alt="">
						<img class="big" :src="getpath('/correct/help03_big','.png')" alt="">
					</div>
					<div :class="ballcurrent==4?'ballitem ac':'ballitem'">
						<img class="sml" :src="getpath('/correct/help04_sml','.png')" alt="">
						<img class="big" :src="getpath('/correct/help04_big','.png')" alt="">
					</div>
					<div :class="ballcurrent==5?'ballitem ac':'ballitem'">
						<img class="sml" :src="getpath('/correct/help05_sml','.png')" alt="">
						<img class="big" :src="getpath('/correct/help05_big','.png')" alt="">
					</div>
				</div>
				<div class="infolist">
					<img class="infoimg" :src="getpath('/correct/cinfo01','.png')" alt="">
					<img class="infoimg" :src="getpath('/correct/cinfo02','.png')" alt="">
					<img class="infoimg" :src="getpath('/correct/cinfo03','.png')" alt="">
					<img class="infoimg" :src="getpath('/correct/cinfo04','.png')" alt="">
					<img class="infoimg" :src="getpath('/correct/cinfo05','.png')" alt="">
					<img class="infoimg" :src="getpath('/correct/cinfo06','.png')" alt="">
				</div>

			</div>

		</div>
		<div class="helppad" :style="{backgroundImage:'url('+ getpath('/correct/helpback_pad','.png') +')'}">
			<p class="htitle">
				<img class="titleline" :src="getpath('/correct/title_l','.png')" alt="">
				<img class="titleimg" :src="getpath('/correct/title_help','.png')" alt="">

				<img @click="gotodown('stick')" class="gocorrect"  :src="getpath('/correct/gocorrect','.png')" alt="">
			</p>

			<div class="ingobox" :style="{backgroundImage:'url('+ getpath('/correct/ingoimg_pad','.png') +')'}">
				<div class="ballbox">
					<div :class="ballcurrent==1?'ballitem ac':'ballitem'">
						<img class="sml" :src="getpath('/correct/help01_sml','.png')" alt="">
						<img class="big" :src="getpath('/correct/help01_big','.png')" alt="">
					</div>
					<div :class="ballcurrent==2?'ballitem ac':'ballitem'">
						<img class="sml" :src="getpath('/correct/help02_sml','.png')" alt="">
						<img class="big" :src="getpath('/correct/help02_big','.png')" alt="">
					</div>
					<div :class="ballcurrent==3?'ballitem ac':'ballitem'">
						<img class="sml" :src="getpath('/correct/help03_sml','.png')" alt="">
						<img class="big" :src="getpath('/correct/help03_big','.png')" alt="">
					</div>
					<div :class="ballcurrent==4?'ballitem ac':'ballitem'">
						<img class="sml" :src="getpath('/correct/help04_sml','.png')" alt="">
						<img class="big" :src="getpath('/correct/help04_big','.png')" alt="">
					</div>
					<div :class="ballcurrent==5?'ballitem ac':'ballitem'">
						<img class="sml" :src="getpath('/correct/help05_sml','.png')" alt="">
						<img class="big" :src="getpath('/correct/help05_big','.png')" alt="">
					</div>
				</div>
				<div class="infolist">
					<img class="infoimg" :src="getpath('/correct/cinfo01','.png')" alt="">
					<img class="infoimg" :src="getpath('/correct/cinfo02','.png')" alt="">
					<img class="infoimg" :src="getpath('/correct/cinfo03','.png')" alt="">
					<img class="infoimg" :src="getpath('/correct/cinfo04','.png')" alt="">
					<img class="infoimg" :src="getpath('/correct/cinfo05','.png')" alt="">
					<img class="infoimg" :src="getpath('/correct/cinfo06','.png')" alt="">
				</div>

			</div>

		</div>

		
		<div class="correct-botton">
			<img class="growup-slogan" :src="getpath('correct/correct_logo', '.png')" alt="">
			<p>跟海外儿童一起练发音>>></p>
			<img class="qr" :src="getpath('correct/qr', '.png?r=2')" alt="">
			<img class="app" :src="getpath('correct/comeCorrect', '.png')" alt="">
			<img @click="downAPP('ios')" class="ios" :src="getpath('correct/ios', '.png')" alt="">
			<img @click="downAPP('andriod')" class="andriod" :src="getpath('correct/andriod', '.png')" alt="">
		</div>



		<pfooter :color="'#1BB1FE'"></pfooter>

	</div>
</template>

<script>
import netFetch from '@/config/api'
import $ from 'jquery'

import pheader from '../components/header'
import pfooter from '../components/footer'
export default {
	name:'wordinfo',
	components:{pheader,pfooter},
	data() {
		return {
			wordobj:{},
			isvideoend:false,
			player:null,
			isvideo:false,
			isWeiXin:false, // 是否是微信浏览器
			isiphonex:false,
			ballcurrent:1
		}
	},
	mounted() {
		document.title = 'Uummii-童伴纠音'
		this.isWeiXin = navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1 ? true : false;
		this.startball()
	},
	methods: {
		godownload(){
			
			if(!this.isdown){
				netFetch('https://php.uummii.online/api/client/download', 'POST', {
					behavior:2,
					source:5
				}).then(res=>{
					this.isdown = true;
				})
			}
			if(this.isIOS){
				if($(window).height()>1000){
					window.location.href = 'https://apps.apple.com/cn/app/童伴成长pro-儿童阅读启蒙双语绘本/id1603196107';
				}else{
					window.location.href = 'https://apps.apple.com/cn/app/童伴成长-儿童阅读启蒙双语绘本/id1603195715';
				}
			}else{
				// if(this.isWeiXin){
				// 	window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=cn.stagekids.app.wordcorrection.android';
				// }else{
					window.location.href = this.downUrl;
				// }
			}
		},
		startball(){
			setInterval(() => {
				this.ballcurrent++;
				if(this.ballcurrent == 6){
					this.ballcurrent = 1;
				}
			}, 2000);
		},
		downAPP(type){
			if(type == 'ios'){
				window.location.href = "https://apps.apple.com/cn/app/%E7%AB%A5%E4%BC%B4%E7%BA%A0%E9%9F%B3-%E5%8D%95%E8%AF%8D%E5%8F%91%E9%9F%B3%E7%A4%BA%E8%8C%83%E8%B7%9F%E8%AF%BB%E7%82%B9%E8%AF%BB%E5%90%AC%E5%86%99/id1581070422";
			}else{
				window.location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=cn.stagekids.app.wordcorrection.android"
			}
		}
	},
}
</script>

<style lang="scss" scoped="">
	.correct{
		width: 100%;
		min-height: 100vh;
		margin: 0 auto;
		box-sizing: border-box;
		.correct-banner{
			width: 750px;
			img {
				width: 100%;
			}
		}
		.bannerpad{
			width: 100%;
			text-align: center;
			background-size: 100% 100%;
			display: none;
			.bannerinner{
				width: 750px;
				bottom: 0%;
			}
		}
		.atitle{
			width: 100%;
			display: flex;
			flex-flow: row nowrap;
			justify-content: flex-start;
			.titleline{
				width: 10px;
				height: 40px;
			}
			.titleimg{
				height: 40px;
				margin-left: 25px;
			}

		}
		.problem{
			width: 750px;
			margin: 40px auto 0;
			position: relative;
			z-index: 2;
			.atitle{
				width: 670px;
				margin: 0 auto 20px;
			}
			.problemimg{
				width: 100%;

			}
		}
		.help{
			width: 750px;
			height: 1183px;
			background-size: 100% 100%;
			margin-top: -120px;
			position: relative;
			z-index: 5;
			box-sizing: border-box;
			padding-top: 150px;
			.htitle{
				width: 670px;
				margin: 0 auto;
				display: flex;
				flex-flow: row nowrap;
				justify-content: flex-start;
				position: relative;
				.titleline{
					width: 10px;
					height: 40px;
				}
				.titleimg{
					height: 40px;
					margin-left: 25px;
				}
				.gocorrect{
					width: 138px;
					height: 49px;
					position: absolute;
					right: 30px;
					top: 50%;
					transform: translateY(-60%);
				}

			}
			.ingobox{
				width: 750px;
				height: 999px;
				margin: 0 auto;
				background-size: 100%;
				.ballbox{
					width: 670px;
					height: 153px;
					margin: 30px auto;
					display: flex;
					flex-flow: row nowrap;
					justify-content: center;
					align-items: center;
					.ballitem{
						width: auto;
						height: auto;
						position: relative;
						&.ac{
							.sml{
								opacity: 0;
								transform: scale(1.33);
								&:nth-child(1){
									margin-left: 0px;
									margin-right: 40px;
								}
								&:nth-child(1),&:nth-child(2),&:nth-child(3){
									margin-left: 20px;
									margin-right: 20px;
								}
								&:nth-child(5){
									margin-left: 0px;
									margin-right: 40px;
								}
							}
							.big{
								opacity: 1;
								transform: translate(-50%,-50%) scale(1.33);
							}
						}
						.sml{
							width: 115px;
							height: 115px;
							transition: all .5s ease-in-out;
							transform-origin: center center;
						}
						.big{
							width: 115px;
							height: 115px;
							position: absolute;
							left: 50%;
							top: 50%;
							transition: all .5s ease-in-out;
							transform: translate(-50%,-50%) scale(1);
							transform-origin: center center;
							opacity: 0;
						}
					}

				}
				.infolist{
					width: 670px;
					margin: 0 auto;
					display: flex;
					flex-flow: row wrap;
					justify-content: space-between;
					position: absolute;
					left: 50%;
					transform: translateX(-50%);
					bottom: 60px;

					.infoimg{
						width: 202px;
						height: 92px;
						margin-top: 10px;
					}
				}

			}
		}
		.helppad{
			width: 100%;
			height: 900px;
			background-size: contain;
			background-repeat: no-repeat;
			margin-top: -120px;
			position: relative;
			z-index: 5;
			box-sizing: border-box;
			padding-top: 100px;
			display: none;
			
			.htitle{
				width: 670px;
				margin: 0 auto;
				display: flex;
				flex-flow: row nowrap;
				justify-content: flex-start;
				position: relative;
				.titleline{
					width: 10px;
					height: 40px;
				}
				.titleimg{
					height: 40px;
					margin-left: 6px;
				}
				.gocorrect{
					width: 138px;
					height: 49px;
					position: absolute;
					right: 30px;
					top: 50%;
					transform: translateY(-60%);
				}

			}
			.ingobox{
				width: 100%;
				height: 550px;
				margin: 0 auto;
				background-size: 100%;
				.ballbox{
					width: 670px;
					height: 100px;
					margin: 40px auto 50px;
					display: flex;
					flex-flow: row nowrap;
					justify-content: center;
					align-items: center;
					.ballitem{
						width: auto;
						height: auto;
						position: relative;
						&.ac{
							.sml{
								opacity: 0;
								transform: scale(1.33);
								&:nth-child(1){
									margin-left: 0px;
									margin-right: 40px;
								}
								&:nth-child(1),&:nth-child(2),&:nth-child(3){
									margin-left: 20px;
									margin-right: 20px;
								}
								&:nth-child(5){
									margin-left: 0px;
									margin-right: 40px;
								}
							}
							.big{
								opacity: 1;
								transform: translate(-50%,-50%) scale(1.33);
							}
						}
						.sml{
							width: 115px;
							height: 115px;
							transition: all .5s ease-in-out;
							transform-origin: center center;
						}
						.big{
							width: 115px;
							height: 115px;
							position: absolute;
							left: 50%;
							top: 50%;
							transition: all .5s ease-in-out;
							transform: translate(-50%,-50%) scale(1);
							transform-origin: center center;
							opacity: 0;
						}
					}

				}
				.infolist{
					width: 670px;
					margin: 0 auto;
					display: flex;
					flex-flow: row wrap;
					justify-content: space-between;
					position: absolute;
					left: 50%;
					transform: translateX(-50%);
					bottom: 60px;

					.infoimg{
						width: 202px;
						height: 92px;
						margin-top: 10px;
					}
				}

			}
		}
		.correct-botton{
			position: relative;
			width: 750px;
			margin: 0 auto;
			height: 457px;
			z-index: 10;
			.growup-slogan {
				top: 19px;
				left: 86px;
				width: 343px;
				position: absolute;
			}
			.qr {
				top: 78px;
				right: 86px;
				width: 137px;
				position: absolute;
			}
			.app {
				top: 155px;
				left: 86px;
				width: 265px;
				position: absolute;
			}
			.ios {
				top: 291px;
				left: 68px;
				width: 306px;
				position: absolute;
			}
			.andriod {
				top: 291px;
				left: 380px;
				width: 306px;
				position: absolute;
			}
			>p {
				position: absolute;
				top: 219px;
				left: 100px;
				font-weight: Medium;
				font-size: 26px;
				text-align: center;
				color: #000000 100%;
			}
		}
	}
	
	@media screen and (min-width: 750px) {
		.correct{
			padding-top: 30px;
			.correct-banner{display: none;}
			.bannerpad{display: block;}
			.help{display: none;}
			.helppad{display: block;}
		}
	}
</style>


// WEBPACK FOOTER //
// src/page/correct.vue